import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ArrowRightIcon, MessageSquareIcon } from 'lucide-react';
import { SEO } from '../../components/SEO';
export const MaatwerkAdviesPage = () => {
  return <main data-id="element-1010">
      <SEO title="Maatwerk Advies | Persoonlijk Styling Advies | BKCustoms" description="Op zoek naar een unieke styling oplossing? Wij bieden persoonlijk advies en maatwerk voor uw specifieke wensen en auto bij BKCustoms in Almere. Vrijblijvend advies." canonical="/diensten/maatwerk-advies" data-id="element-1011" />
      {/* Header Banner */}
      <div className="relative bg-[#0a0a0a] py-28" data-id="element-1012">
        <div className="absolute inset-0 overflow-hidden" data-id="element-1013">
          <div className="absolute inset-0 bg-black/80 z-10" data-id="element-1014"></div>
          <img src="https://images.unsplash.com/photo-1560179707-f14e90ef3623?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2073&q=80" alt="Maatwerk Advies" className="w-full h-full object-cover object-center" data-id="element-1015" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-1016">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-1017">
            Maatwerk <span className="text-[#D6281F]" data-id="element-1018">Advies</span>
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-1019">
            Op zoek naar een unieke styling oplossing? Wij bieden persoonlijk
            advies en maatwerk voor uw specifieke wensen en auto.
          </p>
        </div>
      </div>
      {/* Service Description Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-1020">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1021">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-1022">
            {/* Image Section */}
            <div className="w-full lg:w-1/2" data-id="element-1023">
              <div className="relative" data-id="element-1024">
                <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] via-[#FF6B00] to-[#FFD500] opacity-30 blur-lg rounded-lg" data-id="element-1025"></div>
                <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl" data-id="element-1026">
                  <img src="https://images.unsplash.com/photo-1560179707-f14e90ef3623?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2073&q=80" alt="Maatwerk advies voor car styling" className="w-full h-auto object-cover" data-id="element-1027" />
                </div>
              </div>
            </div>
            {/* Content Section */}
            <div className="w-full lg:w-1/2" data-id="element-1028">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1029">
                Persoonlijk Styling Advies
              </h2>
              <p className="text-white/80 text-lg mb-6 leading-relaxed" data-id="element-1030">
                Bij BKCustoms begrijpen we dat elke auto en elke eigenaar uniek
                is. Daarom bieden we maatwerk advies om de perfecte styling
                oplossing voor uw specifieke wensen en voertuig te creëren.
              </p>
              <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-1031">
                Of u nu op zoek bent naar een subtiele verbetering of een
                complete transformatie, onze experts staan klaar om u te
                adviseren over de beste opties en combinaties van onze diensten.
              </p>
              <div className="space-y-4 mb-8" data-id="element-1032">
                <div className="flex items-center" data-id="element-1033">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1034">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1035" />
                  </div>
                  <span className="text-white/90" data-id="element-1036">
                    Persoonlijke consultatie met styling experts
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1037">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1038">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1039" />
                  </div>
                  <span className="text-white/90" data-id="element-1040">
                    Op maat gemaakte styling voorstellen
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1041">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1042">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1043" />
                  </div>
                  <span className="text-white/90" data-id="element-1044">
                    Combinaties van verschillende diensten
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1045">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1046">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1047" />
                  </div>
                  <span className="text-white/90" data-id="element-1048">
                    Transparante prijsopgave zonder verrassingen
                  </span>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-1049">
                <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-1050">
                  <span className="mr-2" data-id="element-1051">Afspraak maken</span>
                  <ArrowRightIcon size={16} data-id="element-1052" />
                </Link>
                <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-1053">
                  Contact opnemen
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Process Section */}
      <section className="bg-[#0f0f0f] py-20" data-id="element-1054">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1055">
          <div className="text-center mb-16" data-id="element-1056">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1057">
              Ons <span className="text-[#D6281F]" data-id="element-1058">Proces</span>
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-1059">
              Bij BKCustoms volgen we een zorgvuldig proces om tot de perfecte
              maatwerk oplossing te komen.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-1060">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-1061">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-1062">
                1
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-1063">
                Consultatie
              </h3>
              <p className="text-white/80" data-id="element-1064">
                We beginnen met een uitgebreid gesprek over uw wensen,
                voorkeuren en budget om uw visie volledig te begrijpen.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-1065">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-1066">
                2
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-1067">Advies</h3>
              <p className="text-white/80" data-id="element-1068">
                Onze experts stellen verschillende opties voor, inclusief
                visualisaties en gedetailleerde uitleg van de mogelijkheden.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-1069">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-1070">
                3
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-1071">
                Plan van Aanpak
              </h3>
              <p className="text-white/80" data-id="element-1072">
                We ontwikkelen een gedetailleerd plan inclusief tijdlijn,
                materialen en een transparante prijsopgave.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-1073">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-1074">
                4
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-1075">
                Uitvoering
              </h3>
              <p className="text-white/80" data-id="element-1076">
                Na uw goedkeuring voeren we het project uit met de hoogste
                aandacht voor detail en kwaliteit, met regelmatige updates.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Options Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-1077">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1078">
          <div className="text-center mb-16" data-id="element-1079">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1080">
              Populaire <span className="text-[#D6281F]" data-id="element-1081">Combinaties</span>
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-1082">
              Ontdek enkele van onze meest gevraagde styling combinaties die we
              voor klanten hebben gerealiseerd.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1083">
            <div className="bg-[#0f0f0f] border border-[#222] p-8 rounded-lg" data-id="element-1084">
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1085">
                Sport Package
              </h3>
              <p className="text-white/80 mb-6" data-id="element-1086">
                Een complete sportieve upgrade met een combinatie van lichten
                smoken, ramen tinten en ontchromen voor een krachtige
                uitstraling.
              </p>
              <ul className="space-y-2 mb-6" data-id="element-1087">
                <li className="flex items-center text-white/80" data-id="element-1088">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-1089" />
                  Lichten smoken (voor- en achterlichten)
                </li>
                <li className="flex items-center text-white/80" data-id="element-1090">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-1091" />
                  Premium ramen tinting
                </li>
                <li className="flex items-center text-white/80" data-id="element-1092">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-1093" />
                  Complete chrome delete
                </li>
              </ul>
            </div>
            <div className="bg-[#0f0f0f] border border-[#222] p-8 rounded-lg" data-id="element-1094">
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1095">
                Premium Bescherming
              </h3>
              <p className="text-white/80 mb-6" data-id="element-1096">
                Maximale bescherming voor uw auto met een combinatie van
                beschermende wraps en AlloyGator velgbescherming.
              </p>
              <ul className="space-y-2 mb-6" data-id="element-1097">
                <li className="flex items-center text-white/80" data-id="element-1098">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-1099" />
                  Transparante beschermfolie op kwetsbare delen
                </li>
                <li className="flex items-center text-white/80" data-id="element-1100">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-1101" />
                  AlloyGator velgbescherming
                </li>
                <li className="flex items-center text-white/80" data-id="element-1102">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-1103" />
                  UV-werende ramen tinting
                </li>
              </ul>
            </div>
            <div className="bg-[#0f0f0f] border border-[#222] p-8 rounded-lg" data-id="element-1104">
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1105">
                Complete Transformatie
              </h3>
              <p className="text-white/80 mb-6" data-id="element-1106">
                Een volledige makeover voor uw auto met een premium wrap,
                getinte ramen en gesmokte lichten voor een unieke look.
              </p>
              <ul className="space-y-2 mb-6" data-id="element-1107">
                <li className="flex items-center text-white/80" data-id="element-1108">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-1109" />
                  Volledige auto wrap in kleur naar keuze
                </li>
                <li className="flex items-center text-white/80" data-id="element-1110">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-1111" />
                  Complete ramen tinting
                </li>
                <li className="flex items-center text-white/80" data-id="element-1112">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-1113" />
                  Lichten smoken en ontchromen
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonials Section */}
      <section className="bg-[#0f0f0f] py-20" data-id="element-1114">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1115">
          <div className="text-center mb-16" data-id="element-1116">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1117">
              Wat Onze <span className="text-[#D6281F]" data-id="element-1118">Klanten</span> Zeggen
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-1119">
              Ontdek de ervaringen van klanten die gebruik hebben gemaakt van
              ons maatwerk advies.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1120">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-1121">
              <div className="flex items-center mb-4" data-id="element-1122">
                <MessageSquareIcon size={20} className="text-[#D6281F] mr-3" data-id="element-1123" />
                <div className="flex space-x-1" data-id="element-1124">
                  {[...Array(5)].map((_, i) => <div key={i} className="text-[#D6281F]" data-id="element-1125">
                      ★
                    </div>)}
                </div>
              </div>
              <p className="text-white/80 italic mb-6" data-id="element-1126">
                "De persoonlijke aanpak van BKCustoms heeft me echt geholpen bij
                het maken van de juiste keuzes voor mijn BMW. Hun advies was op
                maat en het eindresultaat overtrof mijn verwachtingen!"
              </p>
              <div className="flex items-center" data-id="element-1127">
                <div className="mr-3 w-10 h-10 rounded-full bg-[#222] flex items-center justify-center text-white font-bold" data-id="element-1128">
                  M
                </div>
                <div data-id="element-1129">
                  <div className="text-white font-medium" data-id="element-1130">Mark de Vries</div>
                  <div className="text-white/60 text-sm" data-id="element-1131">BMW M4 eigenaar</div>
                </div>
              </div>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-1132">
              <div className="flex items-center mb-4" data-id="element-1133">
                <MessageSquareIcon size={20} className="text-[#D6281F] mr-3" data-id="element-1134" />
                <div className="flex space-x-1" data-id="element-1135">
                  {[...Array(5)].map((_, i) => <div key={i} className="text-[#D6281F]" data-id="element-1136">
                      ★
                    </div>)}
                </div>
              </div>
              <p className="text-white/80 italic mb-6" data-id="element-1137">
                "Ik wist niet precies wat ik wilde voor mijn auto, maar dankzij
                het maatwerk advies van BKCustoms heb ik nu een unieke look die
                perfect bij mijn stijl past. Zeer tevreden!"
              </p>
              <div className="flex items-center" data-id="element-1138">
                <div className="mr-3 w-10 h-10 rounded-full bg-[#222] flex items-center justify-center text-white font-bold" data-id="element-1139">
                  L
                </div>
                <div data-id="element-1140">
                  <div className="text-white font-medium" data-id="element-1141">Laura Jansen</div>
                  <div className="text-white/60 text-sm" data-id="element-1142">Audi A5 eigenaar</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-[#0a0a0a] py-16 border-t border-[#222]" data-id="element-1143">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-1144">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-1145">
            Klaar voor uw persoonlijke styling advies?
          </h2>
          <p className="text-white/80 mb-8" data-id="element-1146">
            Neem contact met ons op voor een vrijblijvende consultatie of maak
            direct een afspraak voor een persoonlijk gesprek.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-1147">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide" data-id="element-1148">
              Afspraak maken
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10" data-id="element-1149">
              Vraag ons advies
            </Link>
          </div>
        </div>
      </section>
    </main>;
};